import { BottomSheetModal, useModal } from "@becon-team/becon-fe-lib/my-modal";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import store from "store";

import { cn } from "@becon-team/becon-fe-lib/my-tailwind-css";
import { Undefinable } from "@becon-team/becon-fe-lib/my-types";
import { imgDevice } from "assets/img";
import { modalIds } from "libs/my-modal";
import { localStorageKeyPurchasedScanner } from "utils/(localStorage)";
import { projectConfig } from "projectConfig";
import { openBrowser } from "utils/openBrowser";
import { useNavigate } from "react-router";
import { path } from "utils/(path)";
import { useSelector } from "react-redux";
import { RootState } from "store/redux/modules";

type ModalParams = {
  onSuccess?: () => void;
};

export const ScannerInfoB2CModal = () => {
  const modalId = modalIds["scanner-info-b2c"];
  const { t, i18n } = useTranslation();
  const { modal, closeModal } = useModal(modalId);
  const { isOpened, params } = modal;
  const { onSuccess } = (params as Undefinable<ModalParams>) || {};
  const navigate = useNavigate();

  const { activeUser } = useSelector((state: RootState) => ({
    activeUser: state.user && state.user.users ? state.user.users[0] : null,
    account: state.account.account,
  }));
  const userId = activeUser?.user_id;

  return (
    <BottomSheetModal
      className="z-50"
      closeModal={closeModal}
      isOpened={isOpened}
      isCloseModalOutsideClick={true}
      btnSection={
        <div className="space-y-sp-6">
          <button
            className={cn("my-btn-primary w-full opacity-80")}
            onClick={() => {
              // TEST 계정
              if (userId === "9f93e5a0-2481-4edb-a143-16bd38465965") {
                navigate(path.scalpMicroAnalysis());
                return;
              }
              store.set(localStorageKeyPurchasedScanner, true);
              onSuccess && onSuccess();
            }}
          >
            {t("이미 구매했어요")}
          </button>
          <button
            form={modalId}
            className={cn("my-btn-primary w-full")}
            onClick={() => openBrowser(projectConfig.company.contact_us_link(i18n))}
          >
            {t("사전 신청하기")}
          </button>
        </div>
      }
    >
      <div className="p-inner-padding pt-0 space-y-sp-16">
        <div className="flex justify-center items-center">
          <div className="flex justify-center items-center rounded-md bg-[#EAEAFF] h-40ptv p-sp-8 text-sm  text-[#5858AA] ">
            {t("12월 출시 예정")}
          </div>
        </div>
        <div className="text-2xl font-bold text-center"> {t("비컨 스캐너 사전 신청")}</div>
        <div className="text-md text-center">
          <div>{t("하나의 스캐너로 두피부터 피부까지")}</div>
          <div>{t("꾸준히 나의 상태를 확인하면서 관리해보세요!")}</div>
        </div>
        <div className="overflow-hidden flex justify-center h-207ptv">
          <img src={imgDevice} alt="device" className="object-contain" />
        </div>
      </div>
    </BottomSheetModal>
  );
};

export const useScannerInfoB2CModal = () => {
  const { modal, openModal, closeModal } = useModal(modalIds["scanner-info-b2c"]);

  const openModalCallback = useCallback(
    (params: ModalParams) => {
      openModal(params);
    },
    [openModal],
  );

  return {
    openModal: openModalCallback,
    closeModal,
    isOpened: modal.isOpened,
  };
};
